import { render, staticRenderFns } from "./checkbox.vue?vue&type=template&id=5f299683&"
import script from "./checkbox.vue?vue&type=script&lang=js&"
export * from "./checkbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCheckbox,VCol})


/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2585234252/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5f299683')) {
      api.createRecord('5f299683', component.options)
    } else {
      api.reload('5f299683', component.options)
    }
    module.hot.accept("./checkbox.vue?vue&type=template&id=5f299683&", function () {
      api.rerender('5f299683', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/parties/form/checkbox.vue"
export default component.exports